module.exports = __webpack_public_path__ + "assets/img/kv-e630bb67.jpg";